import React from "react";
import { Container, Typography, Box, Stack } from "@mui/material";
import { IAuthor } from "../IBlog";

interface BlogAuthorProps {
  author?: IAuthor;
  authors?: IAuthor[];
}

export const BlogAuthor = ({ author, authors }: BlogAuthorProps) => {
  // Handle multiple authors
  if (authors && authors.length > 0) {
    return (
      <Container>
        <Stack spacing={4}>
          {authors.map((auth, index) => {
            const displayName = auth.names && auth.names.length > 0 
              ? auth.names.join(', ') 
              : auth.name || '';

            return (
              <Box key={index}>
                <Box sx={{ display: "flex", alignItems: "flex-start", gap: 6 }}>
                  {auth.image && (
                    <Box
                      component="img"
                      src={auth.image}
                      alt={displayName}
                      sx={{
                        width: 120,
                        height: 120,
                        borderRadius: "50%",
                        objectFit: "cover",
                        flexShrink: 0,
                      }}
                    />
                  )}
                  <Box sx={{ flex: 1 }}>
                    <Typography 
                      variant="h3" 
                      sx={{ color: "#0F2F4B", fontSize: "24px", fontWeight: "bold", marginBottom: "15px" }}
                    >
                      {displayName}
                    </Typography>
                    {auth.shortBio && (
                      <Typography 
                        variant="body1"
                        dangerouslySetInnerHTML={{ __html: auth.shortBio }}
                      />
                    )}
                  </Box>
                </Box>
                {index < authors.length - 1 && (
                  <Box
                    sx={{
                      width: '75%',
                      height: '1px',
                      backgroundColor: 'rgba(15, 47, 75, 0.15)',
                      marginTop: '30px',
                      marginBottom: '30px',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }}
                  />
                )}
              </Box>
            );
          })}
        </Stack>
      </Container>
    );
  }

  // Handle single author (backward compatibility)
  if (author) {
    const displayName = author.names && author.names.length > 0 
      ? author.names.join(', ') 
      : author.name || '';

    return (
      <Container>
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 6 }}>
          {author.image && (
            <Box
              component="img"
              src={author.image}
              alt={displayName}
              sx={{
                width: 120,
                height: 120,
                borderRadius: "50%",
                objectFit: "cover",
                flexShrink: 0,
              }}
            />
          )}
          <Box sx={{ flex: 1 }}>
            <Typography 
              variant="h3" 
              sx={{ color: "#0F2F4B", fontSize: "24px", fontWeight: "bold", marginBottom: "15px" }}
            >
              {displayName}
            </Typography>
            {author.shortBio && (
              <Typography 
                variant="body1"
                dangerouslySetInnerHTML={{ __html: author.shortBio }}
              />
            )}
          </Box>
        </Box>
      </Container>
    );
  }

  return null;
};

